<template>
  <div >
    <h1 v-if="user_name">{{user_name}}</h1>
    <h2>Rechte</h2>
    <div v-for="(item,index) in categories" :key="index">
      <h3><b-link v-b-toggle="item">{{$t('account.rights')[item]}}</b-link></h3>

      <b-collapse :id="item">
        <b-form-checkbox  @change="all_selection($event,item)"
                          v-model="category_selected[item]"
                          switch>
          Alle auswählen
        </b-form-checkbox>
        <b-form-checkbox v-for="(el,key) in user" :key="key"
                         v-if="el.category === item"
                          @input="single_selection($event,el.category)"
                         v-model="el.checked"
                         switch>
          {{el.title}}
        </b-form-checkbox>
      </b-collapse>
    </div>

  </div>
</template>

<script>
  import axios from "@/store/vue-axios/axios"
  import {GetPermissions} from "@/store/models/account/account_get_permissions";

  export default {
        name: "luma-account-rights",
        props:{
          user_id:Number,
          user_name:String
        },
        data:()=>({
          user:null,
          all_selected:false,
          category_selected:{},
          local_changes:false,
          new_user:{
            username:'',
            email:'',
            password:'',
            password_confirm:''
          }
        }),
        computed:{
          categories(){
            const x = GetPermissions.categories()
            return x
          },
          permissions(){
            const y = this.fill_permissions()
            return y
          }
        },
        methods:{
          fill_permissions(){
            const x = GetPermissions.all().map(el=>({...el,checked:false}))
            return x
          },
          all_selection(val,cat){
            console.log('ALL SELECTION::',cat)
            this.category_selected[cat] = val
            this.user.map((el,index)=>{
              this.category_selected[el.category]
                ? this.user[index].checked = true
                : this.user[index].category === cat
                  ? this.user[index].checked = false
                  : ()=>{}
            })
            this.emitRights()
          },
          single_selection(val,cat){
            val ? undefined : this.category_selected[cat] = false
            this.emitRights()
          },
          // get subuser
          async get_subuser_rights(user = this.user_name){
            if (!user) {user = this.$route.params.username}
            const permissions = this.fill_permissions()
            const res = await axios.get('/account/users/'+user+'/permissions')
              .then(response => {
                console.log('SUBUSER RIGHTS:::',response.data.permissions)
                this.user = response.data.permissions.map(el=>({...el,checked:true}))
                permissions.map(el=>{
                  this.user.map(e=>e.key).includes(el.key) ? ()=>{} : this.user.push(el)
                })
              })
              .catch(error=>error)
          },
          create_new_user(){
            this.user = GetPermissions.all().map(el=>({...el,checked:false}))
          },
          emitRights(){
            this.local_changes = true
            const permissions = []
            this.user.map(el=>{
              el.checked ? permissions.push(el.key) : ()=>{}
            })
            let data = null
            if (this.user_name){
              data = {
                username : this.user_name,
                permissions:permissions
              }
            }
            else {
              data = Object.assign({},this.new_user, {permissions:permissions})
            }
            this.$emit('emitRights',data)
          }
        },
      created() {
        this.user_name  ? this.get_subuser_rights() : this.create_new_user()
      }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/account/details_account/luma-account-rights.vue